import { apiGatewayService } from './../apiService/HttpService';
import { setEndPoint } from './../apiService/SetEndPoint';
import { reportsEndPoints } from './../apiService/ReportsEndPoints';

class DesignersReportService {
  static getDesignersPerformance(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.designersDailyPerformance, ...extraParams),
      params,
    });
  }

  static getDesignersList(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getDesignersList, ...extraParams),
      params,
    });
  }

  static getDesignersProductPerformance(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.designersProductPerformance, ...extraParams),
      params,
    });
  }

  static exportGetDesignersProductPerformance(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.exportDesignersProductPerformance, ...extraParams),
      params,
    });
  }

  static getDesignersReport(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getDesignersReport, ...extraParams),
      params,
    });
  }

  static exportGetDesignersReport(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.exportGetDesignersReport, ...extraParams),
      params,
    });
  }
}
export default DesignersReportService;
